import { useNamespace } from '@lit-element/hooks'
import { GitGraph } from './git-graph-class'
import type { Ref } from 'vue'

let graphId = 0
export default function useGitGraph(isDark: Ref<boolean>) {
  let themeService: any
  const graph = new GitGraph()
  const ns = useNamespace('graph')

  const themeChange = () => {
    isDark.value = !!themeService?.currentTheme?.isDark
  }

  const initTheme = () => {
    themeService = (window as any)['devuiThemeService']
    isDark.value = !!themeService?.currentTheme?.isDark

    if (themeService) {
      themeService.eventBus.add('themeChanged', themeChange)
    }
  }

  const initGraph = (
    element: HTMLElement,
    options: any,
    isDarkMode: boolean
  ) => {
    graph.load(element, options, isDarkMode)
  }

  function getGraphId() {
    graphId += 1
    return `${ns.b()}-${graphId}`
  }

  return {
    initTheme,
    initGraph,
    getGraphId,
  }
}
